import { Loader2 } from 'lucide-react'
import { SearchableSelect } from '@/components/ui/SearchableSelect'
import { cn } from '@/lib/utils/helpers'
import {
  formFieldCell,
  formFieldGridClass,
  formFieldWide,
  labelClass,
  sectionHeadingClass,
} from '../../utils/editPageUi'
import { primaryEntityActionButtonClass, secondaryEntityActionButtonClass } from '@/components/ui/entityActionButtonClasses'
import type { UserManagementAssignPropertiesSectionProps } from '../../types'

export function UserManagementAssignPropertiesSection({
  showAssignProps,
  assignPropOptions,
  assignPropLoading,
  assignPropValue,
  assignPropSubmitting,
  onToggle,
  onAssignPropChange,
  onOpen,
  onSearch,
  onSubmit,
  onCancel,
}: UserManagementAssignPropertiesSectionProps) {
  return (
    <>
      <div className="flex items-center justify-between">
        <span className={cn(sectionHeadingClass, 'mb-0')}>Assign Properties</span>
        <button
          type="button"
          onClick={onToggle}
          className={cn(primaryEntityActionButtonClass, 'h-10 px-4 text-sm font-semibold rounded-xl')}
        >
          {showAssignProps ? 'Cancel' : 'Assign Properties'}
        </button>
      </div>
      {showAssignProps && (
        <div className="mt-4">
          <div className={formFieldGridClass}>
            <div className={cn(formFieldCell, formFieldWide)}>
              <label className={labelClass}>Select Properties</label>
              <SearchableSelect
                options={assignPropOptions}
                value={assignPropValue}
                onChange={onAssignPropChange}
                placeholder="All Properties"
                searchPlaceholder="Search By Property Name"
                onOpen={onOpen}
                onSearch={onSearch}
                loading={assignPropLoading}
                multiple
                className="w-full"
              />
            </div>
          </div>
          <div className="flex items-center gap-3 mt-4">
            <button
              type="button"
              disabled={
                assignPropSubmitting ||
                !assignPropValue ||
                (Array.isArray(assignPropValue) && assignPropValue.length === 0)
              }
              onClick={() => void onSubmit()}
              className={cn(primaryEntityActionButtonClass, 'h-10 px-6 text-sm font-semibold rounded-xl')}
            >
              {assignPropSubmitting && <Loader2 className="h-4 w-4 shrink-0 animate-spin" />}
              Assign
            </button>
            <button
              type="button"
              onClick={onCancel}
              className={cn(secondaryEntityActionButtonClass, 'h-10 px-6 text-sm font-semibold rounded-xl')}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  )
}
